<template>
  <div
    class="mx-auto px-4 lg:divide-y lg:divide-gray-200 bg-gray-900 shadow-md"
  >
    <div class="relative h-16 flex justify-between">
      <div class="relative z-10 px-2 flex lg:px-0">
        <div class="flex-shrink-0 flex items-center">
          <img
            class="block h-8 w-auto"
            src="https://www.raspberrypi.org/documentation/pico/getting-started/static/pico-board-c87f938e4e889e9cbac0f5bc1ff27f30.png"
            alt="Workflow"
          />
        </div>
      </div>
      <div
        class="relative z-0 flex-1 px-2 flex items-center justify-center sm:absolute sm:inset-0"
      >
        <div class="w-full sm:max-w-xs">
          <div class="relative">
            <div>
              <div class="mt-1 flex rounded-md shadow-sm">
                <input
                  type="text"
                  class="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md focus:outline-none focus:border-white sm:text-sm border-gray-600 bg-gray-800 text-white"
                  placeholder="No File Loaded"
                  v-model="state.filename"
                  readonly
                />
                <span
                  class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-600 bg-gray-800 text-gray-50 sm:text-sm"
                >
                  .py
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative z-10 ml-4 flex items-center">
        <h1 class="font-bold text-green-300 mr-4" v-if="state.opened">
          CTRL+S to save
        </h1>
        <button
          type="button"
          @click="open"
          class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white hover:border-blue-500 hover:text-blue-500 transition-all border-white focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="-ml-1 mr-2 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
            />
          </svg>

          Open Code
        </button>
        <button
          type="button"
          @click="state.isModalOpen = true"
          v-if="!state.opened"
          class="inline-flex items-center ml-4 px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white hover:border-green-500 hover:text-green-500 transition-all border-white focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="-ml-1 mr-2 h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
          Download
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { state } from "@/state";
import { open, write } from "../fs.js";

export default defineComponent({
  name: "Nav",
  setup() {
    return { state, open, write };
  }
});
</script>
